<template>
	<div class="flex items-center bg-white max-w-xs w-full rounded-full leading-tight sm:max-w-sm md:max-w-lg lg:max-w-sm">
		<h3 class="text-5xl flex-none font-black text-dish-red border-5 -mx-px text-center rounded-full border-dish-red w-20 h-20 flex justify-center items-center md:h-24 md:w-24 md:text-6xl md:-m-1">
			<span class="-mt-1 leading-none">{{ number }}</span>
		</h3>
		<p class="text-lg leading-tight pl-4 pr-6 md:text-2xl md:px-8 lg:px-5 lg:text-xl">{{ text }}</p>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'

	export default defineComponent({
		props: {
			number: {
				type: Number,
				required: true,
			},
			text: {
				type: String,
				required: true,
			},
		},
	})
</script>
